const property = {
	//#region ** KM PERCORSI **
	kmTraveled: {
		color : "#236991"
	},
	//#endregion ** KM PERCORSI **

	//#region ** CONSUMO MEDIO **
	avgConsumption: {
		colorLine : "#01a020",
		colorDot: "#06b943"
	},
	//#endregion ** CONSUMO MEDIO **

	//#region ** ALLARMI **
	alarms: {
		colorMax : [254, 131, 1],
		colorMin: [254, 220, 1]
	},
	//#endregion ** ALLARMI **

	//#region ** EMISSIONI **
	co2Emitted: {
		colorLine : "#686964",
		colorDot: "#999999"
	},
	//#endregion ** EMISSIONI **

	//#region ** DRIVE IDLE TIME **
	driveIdleTime: {
		colorDrive : "#518f8f",
		colorIdle: "#b8d5d5"
	},
	//#endregion ** DRIVE IDLE TIME **
}

export default property;